import React from 'react';
import { CustomerStat } from '../customersTypes';
import styles from './CustomerStatCard.module.css';

interface CustomerStatCardProps {
  stat: CustomerStat;
  icon: React.ReactNode;
}

export const CustomerStatCard: React.FC<CustomerStatCardProps> = ({ stat, icon }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.iconWrapper} style={{ background: stat.iconBg }}>
          <span style={{ color: stat.iconColor }}>{icon}</span>
        </div>
        <span className={styles.label}>{stat.label}</span>
      </div>
      <p className={styles.value}>{stat.value}</p>
      <p className={styles.change}>{stat.change}</p>
    </div>
  );
};
